import React from 'react';
import type { CarouselControlDirection } from './types';
import { ChevronLeftIcon, ChevronRightIcon } from '@fronton/icons-react';

export const DirectionIcon = ({ direction = 'left' }: { direction?: CarouselControlDirection }) => {
  if (direction === 'right')
    return <ChevronRightIcon type="outline" size="l" color="text-primary" data-qa="right-icon" />;

  return <ChevronLeftIcon type="outline" size="l" color="text-primary" data-qa="left-icon" />;
};
